// extracted by mini-css-extract-plugin
module.exports = {"error":"Actualites_error__184cx","wrapper":"Actualites_wrapper__rwgvP","title":"Actualites_title__Bl1kf","single":"Actualites_single__L3KGc"};